import React from "react";
import { useLocation } from "react-router-dom";
import { Phone } from "@phosphor-icons/react";
import { useContent } from "@/context/ContentContext";
import { telHref } from "@/lib/content";

export default function MobileCTA() {
  const { contact } = useContent();
  const location = useLocation();
  if (location.pathname.startsWith("/admin")) return null;

  return (
    <div
      data-testid="mobile-sticky-cta"
      className="md:hidden fixed bottom-0 inset-x-0 z-40 grid grid-cols-2 border-t border-border bg-background/95 backdrop-blur-xl"
    >
      <a
        href={telHref(contact.phone)}
        data-testid="mobile-cta-call"
        className="flex items-center justify-center gap-2 py-4 text-xs uppercase tracking-label font-semibold border-r border-border"
      >
        <Phone size={16} weight="light" /> Ring
      </a>
      <a
        href="/kontakt"
        data-testid="mobile-cta-book"
        data-track="cta_click"
        className="flex items-center justify-center py-4 text-xs uppercase tracking-label font-semibold bg-foreground text-background"
      >
        Book rådgivning
      </a>
    </div>
  );
}
